<h1 class="container-heading">Kit stock{{ item ? " - " + item : "" }}</h1>

<mat-card>
    <mat-card-content>

        <table class="table" *ngIf="rows.length">
            <thead>
                <tr>
                    <th>Hub</th>
                    <th class="text-right">Buildable kits</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of rows">
                    <td>{{ row.hub }}</td>
                    <td class="text-right">{{ row.buildable }}</td>
                </tr>
            </tbody>
        </table>

        <p *ngIf="loaded && !rows.length">
            No stock of the child parts was found in any hub.
        </p>

    </mat-card-content>
</mat-card>
